// Fixed palette for neighbor anchors (Tailwind 500-ish, distinct hues, dark-mode safe).
// Assigned by anchor order so colors stay stable within one render.
const NEIGHBOR_PALETTE = [
  '#ef4444', // red
  '#f59e0b', // amber
  '#a855f7', // purple
  '#0ea5e9', // sky
  '#22c55e', // green
  '#ec4899', // pink
  '#14b8a6', // teal
  '#f97316', // orange
];

export const OWN_COLOR = '#3b82f6'; // blue-500 — this category's clusters

export function neighborhoodColor(anchorOrder: number): string {
  return NEIGHBOR_PALETTE[anchorOrder % NEIGHBOR_PALETTE.length];
}
